export default "/_next/static/assets/AvenirNext-Bold_32dd81cdd3044ef642b01e892a040835.woff2";